<template>
  <div class="analytics-page" >
    <div class="chart-container">
    
      <div id="chart" >
        <apexchart :key="chartKey" type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
      <div class=" p-2">
        <div class="legend-item">
          <div class="color-box red"></div>
          <span>Earnings</span>
        </div>       
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';


export default {
  props: {
    lineChart: {
      type: Array,
      required: true,
    },
  },
  watch: {
    lineChart: {
      immediate: true,
      handler(newData) {
        
        this.updateChart(newData);
        setTimeout(() =>{
          
        }, )
      },
    },
  },
  methods: {

    updateChart(data) {     
      if (data.length === 0) {
      this.series[0].data 
      } else {
      // const counts = data.map(sSpend => parseInt(sSpend.totalamount)); 
      const counts = data.map(val => (val.earning)); 
      this.series[0].data = counts       
      }        
      this.chartKey ++; 
      this.fillXAxisWithDates(data);
    },

    fillXAxisWithDates(data) {
      let dates = [];

      if (data.length === 0) {
        // fallback: generate last 10 days
        for (let i = 9; i >= 0; i--) {
          dates.push(moment().subtract(i, 'days').format('MMM-DD'));
        }
        dates.push(moment().format('MMM-DD'));
      } else {
        dates = data.map(item => {
          // Check if label is full date (YYYY-MM-DD)
          if (item.label.includes('-')) {
            return moment(item.label).format('MMM-DD'); // e.g. 2025-08-01 -> Aug-01
          } else {
            return item.label; // already "Jan", "Feb", etc.
          }
        });
      }

      this.chartOptions.xaxis.categories = dates;
    }


  },

  data: function () {
    return {
      chartKey: 0,
      loading: false, 
      series: [{
        name: "Earnings",
        data: [8, 100, 10, 9, 70, 60, 50, 10, 30, 20, 0]
      }],
      chartOptions: {
        chart: {
          toolbar: {
            show: true,
            tools: {
              download: false
            }
          },
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight',
        
          width: 2
        },
        // title: {
        //   text: 'Shipping Spend',
        //   align: 'left'
        // },
        grid: {
          row: {
            // colors: ['#EA3C531A', 'transparent'], 
            opacity: 0.5        
          },
          column: {
            // colors: ['#EA3C531A', 'transparent'],
            opacity: 0.5
            // columnWidth: '15%'
          }
        },
        xaxis: {
          categories: [],
        },
        
        yaxis: {
          title: {
            text: "Amount (₦)",
            style: {
              fontSize: '14px',
              fontWeight: 'bold',
            }
          },
          labels: {
            formatter: function (val) {
              // return "₦" + val.toLocaleString(); // format with ₦ and commas
              return  val.toLocaleString(); // format with only commas
            }
          }
        },
        
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return "" + val + ""
              // return "# " + val + " thousands"
            }
          }
        },
        colors: ['#EA3C531A']
      },
    }
  },

}
</script>

<style scoped>
.analytics-page {
  width: 97%;
  padding: 20px;
  border: 2px solid transparent;
  margin-bottom: 5%;
  margin-top: 4%;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 2px #00000014;
}

.chart-container {
  height: 400px;
}

.legend-item {
  display: flex;
  align-items: center;
}

.color-box {
  width: 15px;
  height: 15px;
  border-radius: 15px;
}

span {
  margin-left: 7px;
}

.horixon {
  border: 0.5px solid #9BA0A7;
}

.red {
  background-color: #EA3C53;
}
</style>